import ClientProfileSocialView from "./ClientProfileSocialView";
import { useAdminHubUi } from "../../../hooks/useAdminAppMode";
import aa from "../AdminPortal/adminApp.module.css";

export default function ClientProfileSinglePage(props) {
  const isApp = useAdminHubUi();

  return (
    <div className={isApp ? aa.clientPage : undefined}>
      <ClientProfileSocialView {...props} />
    </div>
  );
}
